import * as types from './types'

export default {
  [types.CONSULTANTS]: state => {
    return state.consultants
  },
  [types.KPI_LIST]: state => {
    return state.kpiList
  },
  [types.NEW_CAMPAIGN_KPI_SIDEBAR]: state => {
    return state.newCampaignKpiSidebar
  },
  [types.CAMPAIGNS_KPI]: state => {
    return state.campaigns
  },
}
